import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { QueryRequestModel } from 'src/app/core/models/QueryRequestModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { XlsxService } from 'src/app/shared/services/xlsx.service';
import { TableColumns } from '../Shared/TableColumns';
import { DeleteQueryComponent } from '../delete-query/delete-query.component';

@Component({
  selector: 'app-pending-query',
  standalone: false,
  templateUrl: './pending-query.component.html',
  styleUrl: './pending-query.component.less'
})
export class PendingQueryComponent implements OnInit {
  currentUser: User = new User();
  pendingQueryRequest: QueryRequestModel[] = [];
  filteredQueryRequest: QueryRequestModel[] = [];
  selectedQuery: QueryRequestModel = new QueryRequestModel();
  queryResponseEnum = QueryStatus.Responded;
  queryAssgnToDepRepEnum = QueryStatus.AssignedToDeptRep;
  queryRecycledEnum = QueryStatus.Recycled;
  queryAnsweredBySponsorEnum = QueryStatus.QueryAnsweredBySponsor;
  queryAnsweredByDeptEnum = QueryStatus.QueryAnsweredByDeptRep;

  queryDeleteByAdminEnum = QueryStatus.DeletedByRFCAdmin;
  queryDeleteByPartnerEnum = QueryStatus.DeletedByPartner;
  pendingTableColumns = TableColumns.NON_PARTNER_TABLE_COLUMNS;

  config: any;
  currentPageSize = 10;
  sortingName: string = "RequestedDate";
  isDesc: boolean = true;

  searchText: string = "";
  exportData = [];
  constructor(private router: Router, public datepipe: DatePipe,
    private messageService: NzMessageService,
    private userService: UserService,
    private modalService: NzModalService,
    private queryService: ClarificationQueryListService,
    public xlxsService: XlsxService) { }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    if (this.currentUser.Is_Partner) {
      this.router.navigate(['/unauthorize']);
    }
    if(this.currentUser.IsRFCAdmin) 
      this.pendingTableColumns = TableColumns.NON_PARTNER_TABLE_COLUMNS;
    else 
      this.pendingTableColumns = TableColumns.getFilteredColumns(TableColumns.NON_PARTNER_TABLE_COLUMNS, ['Action']);
      
    this.queryService.getPendingQueries(this.currentUser.User_Code ?? 0, 0).subscribe((response: any) => {
      this.pendingQueryRequest = response.output;
      this.filteredQueryRequest = this.pendingQueryRequest.filter(s => s.QueryDetailsStatus);
      this.config = {
        itemsPerPage: this.currentPageSize,
        currentPage: 1,
        totalItems: 0
      }
      
    }, error => {
      this.messageService.error("Error occurred while fetching pending query details");
      console.log(error);
    });
  }
  onSearch(): void {
    const searchTextLower = this.searchText.toLowerCase();

    // Only filter if the search text has at least 3 characters
    if (searchTextLower.length >= 3) {
      this.filteredQueryRequest = this.pendingQueryRequest.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTextLower)
        )
      );
    } else {
      // Reset the filtered data to the original data if search text is less than 3 characters
      this.filteredQueryRequest = [...this.pendingQueryRequest];
    }
  }
  // Deactivate a company
  showDeleteConfirm(queryData: QueryRequestModel): void {
    this.modalService.confirm({
      nzTitle: 'Confirm !',
      nzContent: 'Are you sure, you want to <strong>Delete</strong> Query - <span class="referanceNumber"> ' + queryData.QueryRequestNumber + '</span>?',
      nzOkText: 'Yes',
      nzWidth: '500px',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzClosable: false,
      nzAutofocus: null,
      nzOnOk: () => this.OnDeleteClick(queryData),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  OnDeleteClick(queryData: QueryRequestModel) {
    this.modalService.create({
      nzTitle: '<span class="referanceNumber"> Delete Query</span>',
      nzOkText: 'Delete',
      nzClosable: false,
      nzFooter: null,
      nzAutofocus: null,
      nzContent: DeleteQueryComponent,
      nzData: { paramRequestModel: queryData },
    });
  }
}
